<template>
    <form @submit.prevent="onSubmit" class="form-horizontal form-material">
        <div class="card text-white bg-danger" v-if="Object.keys(errors).length">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Errors</h4>
            </div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{ errors }}</p>
                <p v-if="typeof errors !== 'string'" class="card-text" v-for="(error, key) in errors" :key="key">
                    {{ key }}:{{ error }}
                </p>
            </div>
        </div>

        <div class="form-row">
            <div class="form-group col-md-10 col-sm-4">
                <label for="campaign_name" class="mt-1">Campaign Name</label>
                <input v-model="campaign.name" type="text" class="form-control" id="campaign_name" name="campaign_name">
                <div v-if="$v.campaign.name.$error">
                    <div class="text-danger" v-if="!$v.campaign.name.required">Name is required.</div>
                    <div class="text-danger" v-if="!$v.campaign.name.minLength">Name must have at least
                        {{ $v.campaign.name.$params.minLength.min }} characters.
                    </div>
                </div>
            </div>
            <div class="col-auto mb-2">
                <input id="v3" v-model="v3" type="checkbox" v-bind:true-value="true" v-bind:false-value="false">
                <label for="v3">Don`t touch</label>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-8">
                <label for="campaign_sender">Campaign Sender</label>
                <small class="form-text text-muted mt-0">
                    You can use here: saved Dynamic tag { } and live Dynamic Tag {value 1|value 2|value 3}
                </small>
                <input v-model="campaign.sender" @focus="setFocus('senderOn')" type="text" class="form-control"
                    id="campaign_sender" name="campaign_sender" ref="sender">
                <div v-if="$v.campaign.sender.$error">
                    <div class="text-danger" v-if="!$v.campaign.sender.required">Sender is required.</div>
                    <div class="text-danger" v-if="!$v.campaign.sender.minLength">Sender must have at least
                        {{ $v.campaign.sender.$params.minLength.min }} characters.
                    </div>
                </div>
            </div>
            <div class="col-4">
                <label for="campaign_sender">&nbsp;</label>
                <small class="form-text text-muted mt-0">Choose to insert</small>
                <treeselect placeholder="Dynamic Tags" :always-open="true" :max-height="110" :options="dynamicTagSelect"
                    :load-options="loadDynamicTags" @select="insertDynamicTag" />
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-8">
                <label for="campaign_defaultCity">Default city</label>
                <small class="form-text text-muted mt-0">
                    You can use here: saved Dynamic tag { } and live Dynamic Tag {value 1|value 2|value 3}
                </small>
                <input v-model="campaign.defaultCity" @focus="setFocus('defaultCityOn')" type="text"
                    class="form-control" id="campaign_defaultCity" name="campaign_defaultCity" ref="defaultCity">
            </div>
        </div>
        <div class="form-row mb-3">
            <treeselect class="em-list" v-model="campaign.emailList" placeholder="Select EmailList"
                :options="emailListSelect" :load-options="loadEmailLists" value-format="object">
                <label slot="option-label" slot-scope="{ node }">
                    <i style="font-size: 0.75em;"
                        v-bind:style="{ color: emailListSelect.find(c => c.id === node.id).color }"
                        class="fas fa-circle"></i>
                    {{ node.label }}
                </label>
            </treeselect>
            <div v-if="$v.campaign.emailList.$error">
                <div class="text-danger" v-if="!$v.campaign.emailList.required">EmailList is required.</div>
            </div>
        </div>
        <div class="form-row mb-3">
            <treeselect v-model="campaign.mailProviders" placeholder="Select Mail Services"
                :options="mailProviderSelect" :load-options="loadMailServices" :multiple="true" value-format="object" />
            <div v-if="$v.campaign.mailProviders.$error">
                <div class="text-danger" v-if="!$v.campaign.mailProviders.required">Field is required.</div>
            </div>
        </div>
        <div class="form-row mb-3">
            <treeselect v-model="campaign.message" placeholder="Select Messages" :options="messageSelect"
                :load-options="loadMessages" value-format="object" />
            <div v-if="$v.campaign.message.$error">
                <div class="text-danger" v-if="!$v.campaign.message.required">Message is required.</div>
            </div>
        </div>
        <div class="form-row mb-3">
            <treeselect v-model="campaign.offer" placeholder="Select Offer" :options="offerSelect"
                :load-options="loadOffers" value-format="object" />
            <div v-if="$v.campaign.offer.$error">
                <div class="text-danger" v-if="!$v.campaign.offer.required">Offer is required.</div>
            </div>
        </div>
        <div class="form-row mb-3">
            <treeselect v-model="campaign.relayStatus" placeholder="Select Relay Status" :options="relayStatuses"
                value-format="object" />
            <div v-if="$v.campaign.relayStatus.$error">
                <div class="text-danger" v-if="!$v.campaign.relayStatus.required">Relay Status is required.</div>
            </div>
        </div>
        <div class="form-row mb-3">
            <treeselect v-model="campaign.relayGroup" placeholder="Select Relay Group" :options="relayGroupSelect"
                :load-options="loadRelayGroups" value-format="object" />
            <div v-if="$v.campaign.relayGroup.$error">
                <div class="text-danger" v-if="!$v.campaign.relayGroup.required">Relay Group is required.</div>
            </div>
        </div>
        <div class="form-row mb-3">
            <div class="col-auto">
                <input v-model="scheduledStart" type="checkbox" v-bind:true-value="true" v-bind:false-value="false">
            </div>
            <div class="col-auto">
                <label for="start_date">Scheduled Start Date (UTC)</label>
                <datetime type="datetime" v-model="campaign.scheduledStart" id="start_date" input-id="start_date"
                    format="yyyy-MM-dd HH:mm" zone="UTC" v-bind:disabled="!scheduledStart"></datetime>
                <div v-if="$v.campaign.scheduledStart.$error">
                    <div class="text-danger" v-if="!$v.campaign.scheduledStart.required">Start Date is required.</div>
                </div>
            </div>
        </div>
        <div class="form-row mb-3">
            <div class="col-auto">
                <input v-model="scheduledStop" type="checkbox" v-bind:true-value="true" v-bind:false-value="false">
            </div>
            <div class="col-auto">
                <label for="stop_date">Scheduled Stop Date (UTC)</label>
                <datetime type="datetime" v-model="campaign.scheduledStop" id="stop_date" input-id="stop_date"
                    format="yyyy-MM-dd HH:mm" zone="UTC" v-bind:disabled="!scheduledStop"></datetime>
                <div v-if="$v.campaign.scheduledStop.$error">
                    <div class="text-danger" v-if="!$v.campaign.scheduledStop.required">Stop Date is required.</div>
                </div>
            </div>
        </div>
        <div class="form-group text-center p-b-20 p-t-5">
            <div class="col-xs-12">
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" v-show="!submitting">
                    Save
                </button>
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" disabled
                    v-show="submitting">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import { minLength, required, requiredIf } from 'vuelidate/lib/validators';
import CampaignService from '../../services/PmtaCampaignService';
import EmailListService from '../../services/EmailListService';
import MessageService from '../../services/MessageService';
import OfferService from '../../services/OfferService';
import RelayGroupService from '../../services/PmtaRelayGroupService';
import Treeselect from '@riophae/vue-treeselect';
import { Datetime } from 'vue-datetime';
import { CampaignType, CampaignStatus, RelayStatus } from '../../constants';
import Swal from 'sweetalert2';
import TagService from '../../services/TagService';
import MailProviderService from '../../services/MailProviderService';
import moment from 'moment';

export default {
    name: 'PmtaCampaignForm',
    components: {
        Treeselect,
        datetime: Datetime
    },
    data() {
        return {
            campaign: {
                name: null,
                emailList: null,
                mailProviders: null,
                message: null,
                offer: null,
                relayStatus: null,
                relayGroup: null,
                sender: null,
                status: CampaignStatus.STATUS_INACTIVE,
                scheduledStart: null,
                scheduledStop: null,
                defaultCity: null
            },
            errors: {},
            dynamicTagSelect: null,
            emailListSelect: null,
            emailListColors: [],
            messageSelect: null,
            offerSelect: null,
            relayGroupSelect: null,
            mailProviderSelect: null,
            relayStatuses: RelayStatus.data,
            submitting: false,
            CampaignStatus: CampaignStatus,
            scheduledStart: false,
            scheduledStop: false,
            focusStatus: '',
            v3: false
        }
    },
    async mounted() {
        if (this.$route.params.id) {
            this.$emit('setLoading', true);
            for (let i = 0; i <= 4; i++) {
                await this.sleep(1000);
                if (this.mailProviderSelect !== null) {
                    break;
                }
                if (i === 3) {
                    await this.$router.push({ name: 'pmtaCampaigns' });
                }
                await this.sleep(1000);
            }
            CampaignService.getCampaign(this.$route.params.id).then(response => {
                this.campaign = response.data;
                if (this.campaign.status !== CampaignStatus.STATUS_INACTIVE) {
                    this.$router.push({ name: 'campaigns' });
                }
                this.campaign.relayStatus = { 'id': this.campaign.relayStatus };
                this.scheduledStart = this.campaign.scheduledStart !== null;
                this.scheduledStop = this.campaign.scheduledStop !== null;
                this.$emit('setLoading', false);
            });
            return;
        }
        if (this.$route.params.cloneId) {
            this.$emit('setLoading', true);
            for (let i = 0; i <= 4; i++) {
                await this.sleep(1000);
                if (this.mailProviderSelect !== null) {
                    break;
                }
                if (i === 3) {
                    await this.$router.push({ name: 'pmtaCampaigns' });
                }
                await this.sleep(1000);
            }
            CampaignService.getCampaign(this.$route.params.cloneId).then(response => {
                this.campaign = response.data;
                this.campaign.relayStatus = { 'id': this.campaign.relayStatus };
                this.scheduledStart = this.campaign.scheduledStart !== null;
                this.scheduledStop = this.campaign.scheduledStop !== null;
                this.campaign.status = CampaignStatus.STATUS_INACTIVE;
                delete this.campaign.id;
                delete this.campaign.endDate;
                delete this.campaign.startDate;
                delete this.campaign.user;
                this.campaign.mailProviders = this.campaign.mailProviders.filter(value => {
                    return (value.name !== 'Trash Mail') && (value.name !== 'GI');
                });
                this.$emit('setLoading', false);
            });
        }
    },
    validations: {
        campaign: {
            name: {
                required, minLength: minLength(1)
            },
            sender: {
                required, minLength: minLength(1)
            },
            emailList: {
                required
            },
            mailProviders: {
                required
            },
            message: {
                required
            },
            offer: {
                required
            },
            relayStatus: {
                required
            },
            relayGroup: {
                required: requiredIf(function () {
                    return this.$route.params.id === undefined
                })
            },
            scheduledStart: {
                required: requiredIf(function () {
                    return this.scheduledStart === true;
                })
            },
            scheduledStop: {
                required: requiredIf(function () {
                    return this.scheduledStop === true;
                })
            },
        }
    },
    methods: {
        setFocus(element) {
            this.focusStatus = element;
        },
        loadMailServices({ callback }) {
            MailProviderService.getProviderSelect().then(response => {
                this.mailProviderSelect = response.data['hydra:member'].map(provider => {
                    return { id: provider.id, label: provider.name }
                });
                if (!this.$route.params.id) {
                    this.campaign.mailProviders = this.mailProviderSelect.filter(value => {
                        return (value.label !== 'Trash Mail') && (value.label !== 'GI');
                    });
                }
                callback();
            });
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        onSubmit() {
            if (this.scheduledStart && this.scheduledStop) {
                if (moment(this.campaign.scheduledStart) > moment(this.campaign.scheduledStop)) {
                    Swal({
                        type: 'warning',
                        title: 'The start date must be earlier than the stop date.',
                    }
                    );
                    return;
                }
            }
            this.$v.$touch();
            if (this.$v.$invalid) return;
            this.submitting = true;

            let campaignClone = Object.assign({}, this.campaign);
            campaignClone.relayStatus = campaignClone.relayStatus.id;
            campaignClone.scheduledStart = this.scheduledStart ? campaignClone.scheduledStart : null;
            campaignClone.scheduledStop = this.scheduledStop ? campaignClone.scheduledStop : null;

            let submitMethod = null;

            if (this.$route.params.id) {
                submitMethod = CampaignService.updateCampaign(this.$route.params.id, JSON.stringify(campaignClone));
            } else {
                submitMethod = CampaignService.createCampaign(JSON.stringify(campaignClone));
            }

            submitMethod.then(response => {
                this.submitting = false;
                if (response.data.error !== undefined) {
                    this.errors = response.data.error;
                } else {
                    this.$router.push({ name: 'pmtaCampaigns' });
                    if (this.scheduledStart !== true) {
                        let start = {
                            id: response.data.id,
                            type: CampaignType.PMTA,
                            v3: this.v3
                        };
                        CampaignService.startCampaign(JSON.stringify(start)).then(response => {
                            if (response.status >= 400) {
                                Swal(
                                    'Oops!',
                                    response.data.error.message,
                                    'error'
                                );
                            }
                        });
                    }
                }
            });
        },
        insertDynamicTag(tag) {
            tag = '{' + tag.label + '}';
            if (this.focusStatus === 'senderOn') {
                let start = this.$refs.sender.selectionStart;
                this.$refs.sender.setRangeText(tag);
                this.$refs.sender.selectionStart = this.$refs.sender.selectionEnd = start + tag.length;
                let e = document.createEvent("UIEvent");
                e.initEvent("input", true, false);
                this.$refs.sender.dispatchEvent(e);
            } else if (this.focusStatus === 'defaultCityOn') {
                let start = this.$refs.defaultCity.selectionStart;
                this.$refs.defaultCity.setRangeText(tag);
                this.$refs.defaultCity.selectionStart = this.$refs.defaultCity.selectionEnd = start + tag.length;
                let e = document.createEvent("UIEvent");
                e.initEvent("input", true, false);
                this.$refs.defaultCity.dispatchEvent(e);
            }
        },
        loadDynamicTags({ callback }) {
            TagService.getTagSelect().then(response => {
                this.dynamicTagSelect = response.data['hydra:member'].map(tag => {
                    return { id: tag.name, label: tag.name }
                });
                callback();
            });
        },
        loadEmailLists({ callback }) {
            EmailListService.getSmartEmailLists().then(response => {
                this.emailListSelect = response.data.items.map(emailList => {
                    return { id: emailList.id, label: emailList.label, color: emailList.color }
                });
                callback();
            });
        },
        loadMessages({ callback }) {
            MessageService.getMessageSelect().then(response => {
                this.messageSelect = response.data['hydra:member'].map(message => {
                    return { id: message.id, label: message.name }
                });
                callback();
            });
        },
        loadOffers({ callback }) {
            OfferService.getOfferSelect().then(response => {
                this.offerSelect = response.data['hydra:member'].map(offer => {
                    return { id: offer.id, label: offer.name }
                });
                callback();
            });
        },
        loadRelayGroups({ callback }) {
            RelayGroupService.getGroupSelect().then(response => {
                this.relayGroupSelect = response.data['hydra:member'].map(group => {
                    return { id: group.id, label: group.name }
                });
                callback();
            });
        },
    }
}
</script>

<style>
.em-list .vue-treeselect__option--selected {
    background: #fde532 !important;
}

.em-list .vue-treeselect__option--selected:hover {
    background: #fda020 !important;
}
</style>
